import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { PrecinctGetAsCollection, PrecinctGetAsCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<PrecinctGetAsCollectionResponse, PrecinctGetAsCollectionResponse>) => {
    return response?.data?.precincts
}
const getError = (response?: SWRResponse<PrecinctGetAsCollectionResponse, PrecinctGetAsCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const usePrecincts = (configuration?: SWRConfiguration<PrecinctGetAsCollectionResponse, PrecinctGetAsCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new PrecinctGetAsCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default usePrecincts;